import { CircularProgress, useMediaQuery } from '@mui/material';
import React from 'react';
import {
  AgencyPlanText,
  DesignerPlanText,
  expert,
  pro
} from 'src/common/config/TextMessage';
import { OrbitAiBannerPlanPage } from './OrbitAiBannerPlanPage';

interface DesktopPlanViewProps {
  tableContainerRef: React.RefObject<HTMLDivElement>;
  isVisible: boolean;
  pageLoad: boolean;
  cardData: any[];
  isLocalSeo: boolean;
  selectedValue: string;
  isCollapsed: boolean;
  setSelectedPlanName: (data: any) => void;
  setInfoModal: (open: boolean) => void;
  recommendedPlan: string;
  transposedData: any[][];
  planIndexCheck: number;
  handlePlanClick?: (data: any, index: number) => void;
  isFromInitialSetup?: boolean;
  planDetails?: any;
  loader?: boolean;
  isShowOrbitAddOn?: boolean;
}

export const PlanViewNew = ({
  tableContainerRef,
  isVisible,
  pageLoad,
  cardData,
  isLocalSeo,
  selectedValue,
  isCollapsed,
  setSelectedPlanName,
  setInfoModal,
  recommendedPlan,
  transposedData,
  planIndexCheck,
  planDetails,
  handlePlanClick,
  isFromInitialSetup = false,
  loader = false,
  isShowOrbitAddOn = false
}: DesktopPlanViewProps) => {
  const [clickedIndex, setClickedIndex] = React.useState<number | null>(null);
  const isMobile = useMediaQuery('(max-width:619px)');
  const resellerLink = 'https://calendly.com/rob-seospace';
  const freePlans = cardData?.filter((item) => item.title === 'Free');
  return (
    <>
      <div
        ref={isFromInitialSetup ? tableContainerRef : null}
        style={{
          paddingLeft: isMobile ? '20px' : '80px',
          paddingRight: isMobile ? '20px' : '80px'
        }}
        className={`font-inter grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 w-full justify-center gap-5 mx-auto mt-4 py-4 max-w-[1600px]`}
      >
        {cardData?.map((item, index) => {
          const handleClick = (index: number) => {
            setClickedIndex(index);
            if (isFromInitialSetup) {
              handlePlanClick?.(item, index);
              return;
            }
            setSelectedPlanName(item);
            setInfoModal(true);
          };
          const transposedDataArray = transposedData;
          const webSiteList = transposedData[0];
          const isAnnually = selectedValue === 'annually';
          const isFree = item.title === 'Free';
          const titleText =
            item.title === DesignerPlanText
              ? pro
              : item.title === AgencyPlanText
              ? expert
              : isFree
              ? ' '
              : item.title;
          const displayTitle =
            titleText && titleText == 'Expert Plus'
              ? 'Expert'
              : titleText == 'Starter Plus'
              ? 'Starter'
              : titleText == 'Pro Plus'
              ? 'Pro'
              : titleText || '--';
          const isStarter =
            displayTitle === 'Starter' ||
            displayTitle === 'DIY' ||
            titleText === 'Starter' ||
            titleText === 'Starter Plus' ||
            titleText === 'DIY';
          const isReseller = titleText == 'Reseller';
          // const isRecommended =
          //   item.title === recommendedPlan ||
          //   (recommendedPlan === 'DIY' && isStarter) ||
          //   (recommendedPlan === 'Starter' && isStarter);

          const hasActivePlan = cardData?.some(
            (c) => c?.isActivePlan || c?.isSubscribedOldPlan
          );

          const isShowBorder =
            item?.isActivePlan ||
            item?.isSubscribedOldPlan ||
            (!hasActivePlan && isAnnually && isStarter);

          if (isFree) {
            return null;
            // return isFree && isLocalSeo ? null : (
            //   <div
            //     key={index}
            //     className={`col-span-full grid grid-cols-1 lg:grid-cols-4 lg:gap-5 w-full bg-[rgba(255,255,255,0.5)] rounded-lg shadow-[0px_4px_4px_0px_#0000000D] overflow-hidden max-w-md md:max-w-none mx-auto md:mx-0 ${
            //       isShowBorder && 'border border-[#AA95E2]'
            //     }`}
            //   >
            //     <div
            //       className={`flex flex-col justify-center gap-2 bg-white lg:col-span-1 p-5 shadow-sm lg:shadow-lg ${
            //         isShowBorder &&
            //         'border-b lg:border-b-0 border-r-0 lg:border-r border-[#AA95E2]'
            //       }`}
            //     >
            //       <span className="text-3xl md:text-[36px] font-bold text-themeBlue leading-none">
            //         {isFree
            //           ? item.title
            //           : isAnnually
            //           ? isReseller
            //             ? item.amount
            //             : `$${(item.unit_amount / 100).toFixed(2)}`
            //           : !item.discountedAmount
            //           ? item.amount
            //           : item.discountedAmount}
            //       </span>
            //       <p
            //         className={`font-inter text-sm font-medium text-themeBlue overflow-hidden transition-all duration-300 ease-in-out ${
            //           isCollapsed ? 'h-0 opacity-0 mb-0' : 'opacity-100'
            //         }`}
            //         title={item.subText || '--'}
            //       >
            //         {item.subText || '--'}
            //       </p>
            //     </div>
            //     <div className="flex flex-col justify-center gap-1.5 lg:gap-2.5 md:col-span-2 p-5 lg:pl-0 w-full">
            //       {transposedDataArray &&
            //         transposedDataArray?.length > 0 &&
            //         transposedDataArray?.map((featureItem, childIndex) => {
            //           if (isFree && featureItem[index]?.value === '-')
            // return null;
            //           return childIndex == 0 || !featureItem[index] ? null : (
            //             <div key={childIndex} className="">
            //               <p className="text-sm font-inter font-medium text-themeBlue mb-0">
            //                 {featureItem[index]?.title || '--'}
            //                 {typeof featureItem[index]?.value !== 'boolean' &&
            //                   featureItem[index]?.value && (
            //                     <span className="font-bold">
            //                       {' '}
            //                       {featureItem[index]?.value}
            //                     </span>
            //                   )}
            //               </p>
            //             </div>
            //           );
            //         })}
            //     </div>
            //     <div className="flex flex-col justify-center items-center pt-0 lg:pt-5 p-5 lg:col-span-1 w-full">
            //       <button
            //         className="flex w-full flex-col font-inter"
            //         disabled={item?.isActivePlan || loader}
            //         onClick={() =>
            //           isReseller
            //             ? window.open(resellerLink, '_blank')
            //             : handleClick(index)
            //         }
            //       >
            //         <p
            //           className={`!border-[2px] border-themeBlue rounded-full flex gap-1 justify-center items-center text-base py-2.5 px-6 transition-all duration-200 ${
            //             item?.isActivePlan
            //               ? 'bg-themeBlue text-white'
            //               : `bg-white text-themeBlue ${
            //                   loader
            //                     ? ''
            //                     : 'hover:bg-themeBlue hover:text-white'
            //                 }`
            //           } mb-0 font-inter font-semibold text-center`}
            //         >
            //           {loader && clickedIndex === index ? (
            //             <CircularProgress size={24} />
            //           ) : isFromInitialSetup ? (
            //             item?.metadata?.display_name?.toLocaleLowerCase() ==
            //             planDetails?.free ? (
            //               'Join Now'
            //             ) : (
            //               '7 Day Free Trial'
            //             )
            //           ) : (
            //             item?.btnText
            //           )}
            //         </p>
            //       </button>
            //       {item?.isSubscribedOldPlan && (
            //         <div className="mt-2.5 text-primary text-xs font-semibold font-inter flex items-center justify-center">
            //           Subscribed to legacy Free plan
            //         </div>
            //       )}
            //       {isFromInitialSetup && (
            //         <p className="mt-2.5 text-xs text-center font-medium text-themeBlue whitespace-nowrap">
            //           {'No Credit Card Required'}
            //         </p>
            //       )}
            //     </div>
            //   </div>
            // );
          }

          return isFree && isLocalSeo ? null : (
            <div
              key={index}
              className="flex flex-col flex-1 w-full max-w-md mx-auto lg:max-w-none"
            >
              {/* Card Top View */}
              <div
                className={`bg-white rounded-tl-lg rounded-tr-lg p-4 sticky ${
                  isFromInitialSetup ? 'top-[78px] md:top-[80px]' : 'top-0'
                } z-10 shadow-[0px_4px_4px_0px_#0000000D] border ${
                  isShowBorder ? 'border-[#AA95E2]' : 'border-transparent'
                }`}
              >
                <div className="flex items-center gap-2 justify-between mb-1 md:min-h-[40px]">
                  <p
                    className={`text-3xl md:text-3xl font-bold text-themeBlue font-inter`}
                  >
                    {displayTitle}
                  </p>
                  {isAnnually && isStarter && (
                    <p className="text-sm uppercase text-themeBlue font-semibold font-inter">
                      &#9889; Most Popular
                    </p>
                  )}
                  {isReseller && (
                    <p className="text-sm uppercase text-themeBlue font-semibold font-inter">
                      &#128142; Resell
                    </p>
                  )}
                </div>
                {/* {isAnnually && !isFree && <p>{item?.discountPercent}</p>} */}
                <p
                  className={`font-inter text-sm font-medium text-themeBlue overflow-hidden transition-all duration-300 ease-in-out ${
                    isCollapsed
                      ? 'h-0 opacity-0 mb-0'
                      : 'md:h-[40px] opacity-100 mb-2.5 md:line-clamp-2'
                  }`}
                  title={item.subText || '--'}
                >
                  {item.subText || '--'}
                </p>
                <div className="flex flex-wrap items-end gap-1 mb-2.5">
                  {/* {item.discountedAmount && (
                    <span className="font-bold text-4xl line-through text-gray-500">
                      {item.amount.split('/')[0]}
                    </span>
                  )} */}
                  <span className="text-3xl lg:text-[32px] xl:text-[40px] font-bold text-themeBlue leading-none">
                    {isFree
                      ? item.title
                      : isAnnually
                      ? isReseller
                        ? item.amount
                        : `$${(item.unit_amount / 100).toFixed(2)}`
                      : !item.discountedAmount
                      ? item.amount
                      : item.discountedAmount}
                  </span>
                  {!isFree && !isReseller && (
                    <span className="text-xl font-bold leading-none text-themeBlue">
                      {isAnnually ? '/yr' : '/mo'}
                    </span>
                  )}
                </div>
                <div className="py-3 px-5 bg-[#f7f1ff] rounded-lg flex items-center justify-between mb-2.5 gap-2">
                  <p className="font-inter text-xl font-bold leading-none text-themeBlue">
                    Websites
                  </p>
                  <p className="font-inter text-3xl font-bold leading-none text-themeBlue">
                    {webSiteList[index]?.value}
                  </p>
                </div>
                <button
                  className={`flex w-full flex-col font-inter`}
                  disabled={item?.isActivePlan || loader}
                  onClick={() =>
                    isReseller
                      ? window.open(resellerLink, '_blank')
                      : handleClick(index)
                  }
                >
                  <p
                    className={`!border-[2px] border-themeBlue rounded-full flex gap-1 justify-center items-center text-base p-3 transition-all duration-200 ${
                      item?.isActivePlan
                        ? 'bg-themeBlue text-white'
                        : `bg-white text-themeBlue ${
                            loader ? '' : 'hover:bg-themeBlue hover:text-white'
                          }`
                    } mb-2.5 font-inter font-semibold`}
                  >
                    {loader && clickedIndex === index ? (
                      <CircularProgress size={24} />
                    ) : isFromInitialSetup ? (
                      item?.metadata?.display_name?.toLocaleLowerCase() ==
                      planDetails.free ? (
                        'Get Started'
                      ) : isReseller ? (
                        'Schedule A Call'
                      ) : (
                        '7 Day Free Trial'
                      )
                    ) : isReseller ? (
                      'Schedule A Call'
                    ) : (
                      item?.btnText
                    )}
                  </p>
                  {/* {isFromInitialSetup && (
                  <p className="text-xs text-center font-medium text-themeBlue">
                    {isReseller
                      ? 'No Commmitment Required'
                      : 'No credit card required'}
                  </p>
                )} */}
                </button>
                {item?.isSubscribedOldPlan && (
                  <div className="text-primary text-xs font-semibold font-inter flex items-center justify-center">
                    Subscribed to legacy{' '}
                    {displayTitle == 'Starter' ? 'DIY' : displayTitle} plan
                  </div>
                )}
              </div>
              {/* Card Feature List View */}
              <div
                className={`p-5 pt-2.5 bg-[rgba(255,255,255,0.5)] rounded-bl-lg rounded-br-lg shadow-[0px_4px_4px_0px_#0000000D] h-full border border-t-0 ${
                  isShowBorder ? 'border-[#AA95E2]' : 'border-transparent'
                }`}
              >
                {transposedDataArray &&
                  transposedDataArray?.length > 0 &&
                  transposedDataArray?.map((item, childIndex) => {
                    if (isFree && item[index]?.value === '-') return null;
                    return childIndex == 0 || !item[index] ? null : (
                      <div key={childIndex} className="mt-2.5">
                        <p className="text-sm font-inter font-medium text-themeBlue">
                          {item[index]?.title || '--'}
                        </p>
                        {typeof item[index]?.value === 'boolean' ? null : (
                          <p className="text-sm font-inter font-bold text-themeBlue">
                            {item[index]?.value || '--'}
                          </p>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div>
      {cardData?.length > 0 && isShowOrbitAddOn && (
        <OrbitAiBannerPlanPage
          selectedValue={selectedValue}
          isFromInitialSetup={isFromInitialSetup}
          isLocalSeo={isLocalSeo}
        />
      )}
      {/* Free plan */}
      {!isLocalSeo && (
        <div
          style={{
            paddingLeft: isMobile ? '20px' : '80px',
            paddingRight: isMobile ? '20px' : '80px'
          }}
          className="w-full max-w-[1600px] mx-auto mt-4 font-inter"
        >
          {freePlans?.map((item, index) => {
            // if (item?.isActivePlan || item?.isSubscribedOldPlan) return null;

            const originalIndex = cardData?.indexOf(item);
            const handleClick = (idx: number) => {
              setClickedIndex(idx);
              if (isFromInitialSetup) {
                handlePlanClick?.(item, idx);
                return;
              }
              setSelectedPlanName(item);
              setInfoModal(true);
            };
            const transposedDataArray = transposedData;
            const isAnnually = selectedValue === 'annually';
            const isFree = item.title === 'Free';
            const isReseller = item.title === 'Reseller';

            return (
              <div
                key={originalIndex}
                className={`grid grid-cols-1 lg:grid-cols-4 lg:gap-5 w-full rounded-lg overflow-hidden max-w-md md:max-w-none mx-auto md:mx-0 border border-[#AA95E2]`}
              >
                <div
                  className={`flex flex-col justify-center gap-2 lg:col-span-1 p-5 border-b lg:border-b-0 border-r-0 lg:border-r border-[#AA95E2]`}
                >
                  <span className="text-3xl md:text-[36px] font-bold text-themeBlue leading-none">
                    {isFree
                      ? item.title
                      : isAnnually
                      ? isReseller
                        ? item.amount
                        : `$${(item.unit_amount / 100).toFixed(2)}`
                      : !item.discountedAmount
                      ? item.amount
                      : item.discountedAmount}
                  </span>
                  <p
                    className={`font-inter text-sm font-medium text-themeBlue overflow-hidden transition-all duration-300 ease-in-out`}
                    title={item.subText || '--'}
                  >
                    {item.subText || '--'}
                  </p>
                </div>
                <div className="flex flex-col justify-center gap-1.5 lg:gap-2.5 md:col-span-2 p-5 lg:pl-0 w-full">
                  {transposedDataArray &&
                    transposedDataArray?.length > 0 &&
                    transposedDataArray?.map((featureItem, childIndex) => {
                      if (isFree && featureItem[originalIndex]?.value === '-')
                        return null;
                      return childIndex == 0 ||
                        !featureItem[originalIndex] ? null : (
                        <div key={childIndex} className="">
                          <p className="text-sm font-inter font-medium text-themeBlue mb-0">
                            {featureItem[originalIndex]?.title || '--'}
                            {typeof featureItem[originalIndex]?.value !==
                              'boolean' &&
                              featureItem[originalIndex]?.value && (
                                <span className="font-bold">
                                  {' '}
                                  {featureItem[originalIndex]?.value}
                                </span>
                              )}
                          </p>
                        </div>
                      );
                    })}
                </div>
                <div className="flex flex-col justify-center items-center pt-0 lg:pt-5 p-5 lg:col-span-1 w-full">
                  <button
                    className="flex w-full flex-col font-inter"
                    disabled={item?.isActivePlan || loader}
                    onClick={() =>
                      isReseller
                        ? window.open(resellerLink, '_blank')
                        : handleClick(originalIndex)
                    }
                  >
                    <p
                      className={`!border-[2px] border-themeBlue rounded-full flex gap-1 justify-center items-center text-base py-2.5 px-6 transition-all duration-200 ${
                        item?.isActivePlan
                          ? 'bg-themeBlue text-white'
                          : `text-themeBlue ${
                              loader
                                ? ''
                                : 'hover:bg-themeBlue hover:text-white'
                            }`
                      } mb-0 font-inter font-semibold text-center`}
                    >
                      {loader && clickedIndex === originalIndex ? (
                        <CircularProgress size={24} />
                      ) : isFromInitialSetup ? (
                        item?.metadata?.display_name?.toLocaleLowerCase() ==
                        planDetails?.free ? (
                          'Join Now'
                        ) : (
                          '7 Day Free Trial'
                        )
                      ) : (
                        item?.btnText
                      )}
                    </p>
                  </button>
                  {item?.isSubscribedOldPlan && (
                    <div className="mt-2.5 text-primary text-xs font-semibold font-inter flex items-center justify-center">
                      Subscribed to legacy Free plan
                    </div>
                  )}
                  {isFromInitialSetup && (
                    <p className="mt-2.5 text-xs text-center font-medium text-themeBlue whitespace-nowrap">
                      {'No Credit Card Required'}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {cardData?.length > 0 && (
        <div className="flex items-center text-center text-xs md:text-sm font-semibold text-primary justify-center px-4 mt-5">
          All plans include every feature. No artificial restrictions.
          Upgrade,downgrade or cancel anytime.
        </div>
      )}
    </>
  );
};
